import styled from 'styled-components'
import { Box } from '../../../UI/Box'
import { useSelector } from 'react-redux'
import {
  selectCurrentQuestionIndex,
  selectQuestions,
} from '../../../../modules/formQuestion/selectors'
import FormSelectInput from './FormSelectInput'
import { ThemedButton } from '../../../ThemedButton'
import VideoUploadSelector from '../../../Uploaders/VideoUploadSelector'
import { useState } from 'react'

const QuestionWrapper = styled(Box)`
  padding: 0 2rem;
  h2 {
    font-feature-settings: 'ss01' on;

    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    line-height: 34px; /* 121.429% */
  }
`

const TextArea = styled.textarea`
  width: 60%;
  display: flex;
  outline: none;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid #ffffff14;
  border-radius: 8px;
  background-color: #030b11;
  min-height: 120px;
  padding: 16px;
  resize: none;
  @media screen and (max-width: ${({ theme }) =>
      theme.layout.compact.maxWidth}px) {
    font-size: 16px;
    width: 100%;
  }
`

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Question = ({
  textAnswer,
  setTextAnswer,
  selectedOptions,
  setSelectedOptions,
  fileUrl,
  setFileUrl,
  handleSubmit,
  isDisabled,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const questions = useSelector(selectQuestions) || {}
  const currentQuestionIndex = useSelector(selectCurrentQuestionIndex)

  const currentQuestion = questions[currentQuestionIndex]

  return (
    <QuestionWrapper gap={48} dc>
      <HeadingWrapper>
        <h2>{currentQuestion.title}</h2>
        {currentQuestion.type === 'multiple_choice' ? (
          currentQuestion.isMultipleSelection ? (
            <p>Select all that apply</p>
          ) : (
            <p>Please select any one</p>
          )
        ) : null}
      </HeadingWrapper>
      {currentQuestion.type === 'text' && (
        <TextArea
          placeholder="Type your answer here..."
          name="answer"
          onChange={(e) => setTextAnswer(e.target.value)}
          value={textAnswer}
        />
      )}
      {currentQuestion.type === 'multiple_choice' && (
        <FormSelectInput
          options={currentQuestion.choices}
          isMultipleSelect={currentQuestion.isMultipleSelection}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
        />
      )}
      {currentQuestion.type === 'file_upload' && (
        <VideoUploadSelector
          projectId={currentQuestion.projectId}
          fileUrl={fileUrl}
          setFileUrl={setFileUrl}
          setIsUploading={setIsLoading}
        />
      )}
      <ThemedButton
        $styleType="primary"
        onClick={handleSubmit}
        disabled={isDisabled || isLoading}
      >
        Ok
      </ThemedButton>
    </QuestionWrapper>
  )
}

export default Question
